/**
***  標準のバリデーション用メソッド
**/



import { DateTime } from 'luxon';



// value の空チェック
// 空だと true を返す
window.emptyValue = (value) => {
  return value === '' || value === undefined || value === null || value.length === 0;
};



// value の値があるかチェック
// 値があったら true を返す
window.hasValue = (value) => {
  return value !== undefined && value !== null && value.length > 0;
};



export const method = {
  required: function(value, element, params){
    return value !== undefined && value !== null && value.length > 0;
  },
  kana: function(value, element, params){
    return emptyValue(value) || /^([ぁ-んァ-ンヴー( |　)]+)$/.test(value);
  },
  alphabet: function(value, element, params){
    return emptyValue(value) || /^[a-zA-Z]+$/.test(value);
  },
  number: function(value, element, params){
    return emptyValue(value) || /^[0-9]+$/.test(value);
  },
  zip: function(value, element, params){
    return emptyValue(value) || /^\d{7}$/.test(value);
  },
  tel: function(value, element, params){
    return emptyValue(value) || /^\d{10,11}$/.test(value);
  },
  mail: function(value, element, params){
    return emptyValue(value) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
  },
  year: function(value, element, params){
    const date = new Date();
    return emptyValue(value) || value <= date.getFullYear();
  },
  month: function(value, element, params){
    return emptyValue(value) || value <= 12 && value > 0;
  },
  day: function(value, element, params){
    return emptyValue(value) || value <= 31 && value > 0;
  },
  date: function(value, element, params){
    const checkDate = DateTime.fromSQL(value);
    return emptyValue(value) || checkDate.isValid;
  },
};
